export default __webpack_public_path__ + "static/media/lock-gray.96bf6e8a.svg";